module.exports = __webpack_public_path__ + "static/media/mode-54.c6db784b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-54.svg
// module id = 1026
// module chunks = 2